import {Fragment, useEffect, useRef, useState} from "react";
import {NavLink} from "react-router-dom";
import {Image} from "react-bootstrap";

import MobileHeader from "./MobileHeader";
import NavItem from "../../navigation/NavItem";
import {useTheme} from "../../hooks/useTheme";
import {useMobileNav} from "../../hooks/useMobileNav";
import MenuSVG from "../../../assets/images/svgs/menu.svg";
import GetStartedButton from "../../buttons/GetStartedButton";
import truQLogo from "../../../assets/images/pngs/truq-logo.png";
import ArrowUpSVG from "../../../assets/images/svgs/arrow-up.svg";
import MenuWhiteSVG from "../../../assets/images/svgs/menu-white.svg";
import ArrowDownSVG from "../../../assets/images/svgs/arrow-down.svg";
import {AppTheme, MenuType, NavItemType} from "../../../modules/enums";
import ArrowUpWhiteSVG from "../../../assets/images/svgs/arrow-up-white.svg";
import truQLogoWhite from "../../../assets/images/pngs/truq-logo-white.png";
import ArrowDownWhiteSVG from "../../../assets/images/svgs/arrow-down-white.svg";
import {CompanyData, NavItems, ProductsData, ResourcesData} from "../../../utils/mapper/Mapper";
import GetQuoteButton from "../../buttons/GetQuoteButton";


const Header = ({theme = AppTheme.LIGHT}: { theme?: AppTheme }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const appTheme = useTheme(), navMode = useMobileNav()
  const [activeNavItem, setActiveNavItem] = useState<NavItemType | null>(null);
  const darkMode = appTheme.theme === AppTheme.DARK || theme === AppTheme.DARK;
  const itemData = !activeNavItem ? null : activeNavItem === NavItemType.PRODUCTS ? ProductsData : activeNavItem === NavItemType.COMPANY ? CompanyData : ResourcesData;

  // Close the dropdown menu when clicked outside or widow changes
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setActiveNavItem(null);
      }
    };

    // Close the dropdown when switching browser windows
    const handleWindowBlur = () => setActiveNavItem(null);

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('blur', handleWindowBlur);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('blur', handleWindowBlur);
    };

  }, []);


  return (
    <Fragment>
      <header className={`fixed-top ${darkMode ? "bg-dark" : "bg-white"}`}>
        <div className="announcement-bar">
          <span>Move single items without paying for a full Van.</span>
          <a href="https://wa.me/2348144968867" target="_blank" rel="noopener noreferrer" className="announcement-bar__contact">
            Reach us on WhatsApp
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 24 24" fill="currentColor" style={{verticalAlign: "middle", marginLeft: "4px", marginBottom: "2px"}}>
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
          </a>
        </div>
        <nav>
          <NavLink to={`/${MenuType.HOME}`} className="my-auto">
            {darkMode ?
              <Image src={truQLogoWhite} alt="truQ Logo" width={60} height={25}/>
              : <Image src={truQLogo} alt="truQ Logo" width={60} height={25}/>
            }
          </NavLink>
          <ul className="nav col-12 col-lg-auto mx-lg-auto  justify-content-center font-size-14 gap-2 gap-md-5 mb-md-0">
            {NavItems.map(item =>
              <li key={item.type} onMouseEnter={() => setActiveNavItem(item.type)}
                  onClick={() => setActiveNavItem(item.type)}>
                <button className={`nav-link px-2 ${darkMode ? "text-white" : ""}`}>{item.name}
                  {activeNavItem === item.type ? <Image
                      className="ms-2"
                      alt="ARROW_DOWN"
                      src={darkMode ? ArrowUpWhiteSVG : ArrowUpSVG}/>
                    : <Image
                      className="ms-2"
                      alt="ARROW_DOWN"
                      src={darkMode ? ArrowDownWhiteSVG : ArrowDownSVG}/>
                  }
                </button>
              </li>
            )}
          </ul>

          <div className="header-actions gap-4">
            <GetQuoteButton/>
            <GetStartedButton/>
          </div>

          {!navMode.navMenu &&
						<Image className="menu" src={darkMode ? MenuWhiteSVG : MenuSVG} alt="menu" width={24} height={24}
									 onClick={() => navMode.toggleNavMenu(true)}/>}
        </nav>

        {itemData &&
					<div ref={dropdownRef} className="d-flex justify-content-center" onMouseLeave={() => setActiveNavItem(null)}>
						<div className={`header-item-container ${activeNavItem ? "show" : "hide"}`}>
              {itemData.map((data, index) =>
                <NavItem key={index} {...data} className={darkMode ? "text-white" : ""}
                />
              )}
						</div>
					</div>
        }
      </header>

      <MobileHeader isDarkMode={darkMode}/>
    </Fragment>
  );
}

export default Header;
